import axios from '@didi/dajax';
import qs from 'qs';
import getCommonParams from './getCommonParams';
import getRequestCommonConfig from './getRequestCommonConfig';
import './interceptors';
import fingerprint from '@/utils/fingerprint';

axios.defaults.timeout = 60000;

function merge(object, ...rest) {
  return Object.assign({}, object, ...rest);
}

export async function get(url = '', data, config) {
  await fingerprint.init();
  const commonParams = await getCommonParams();
  const commonConfig = getRequestCommonConfig();
  return axios.get(
    url,
    merge(commonConfig, config, { params: merge(commonParams, data) })
  );
}

export async function post(url = '', data = {}, config = {}) {
  await fingerprint.init();
  const commonParams = await getCommonParams();
  const commonConfig = getRequestCommonConfig();
  return axios.post(
    url,
    qs.stringify(merge(commonParams, data)),
    merge(commonConfig, config)
  );
}
